class AdpToastController {
  constructor() {
    this.name = 'adpToast';
    this.isHidden = false;
  }
}

export default AdpToastController;



// WEBPACK FOOTER //
// ./src/app/components/adpToast/adpToast.controller.js